
<template>
<div class="user-login pb-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="card overflow-hidden">
            <div class="row g-0">
                <div class="col-lg-6 order-lg-2">
                    <div class="p-lg-5 p-4">
                        <div class="mb-5">
                            <h1 class="h3 text-primary">Candidate Login</h1>
                            <p class="text-muted">Sign in to take your test, check exam details, and view results.</p>
                        </div>
                        <div class="">
                            <user-login-form @takeAction="takeAction($event)" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="p-lg-5 p-4 auth-one-bg h-100" >
                        <div class="bg-overlay"></div>
                        <div class="position-relative h-100 d-flex flex-column">
                            <div class="mb-4">
                                <a :href="absoluteUrl()" class="d-block">
                                    <img :src="absoluteUrl('/images/logos/logo-dark.webp')"  alt="" height="30">
                                </a>
                            </div>
                            <div class="mt-auto ">
                                <div class="mb-5">
                                    <h1 class="fw-bold text-white">Akwa Ibom State Computer-Based Test Portal</h1>
                                </div>
                                <div class="mb-3">
                                    <i class="ri-double-quotes-l display-4 text-warning"></i>
                                </div>

                                <div id="qoutescarouselIndicators" class="carousel slide pointer-event" data-bs-ride="carousel">
                                    <div class="carousel-indicators">
                                        <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="0" class="" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="1" aria-label="Slide 2" class="active" aria-current="true"></button>
                                        <button type="button" data-bs-target="#qoutescarouselIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    </div>
                                    <div class="carousel-inner text-center text-white pb-5">
                                        <div class="carousel-item">
                                            <h6 class="text-white">Excellence Through Merit</h6>
                                            <p class="fs-15 fst-italic">Empowering candidates through transparent and credible computer-based testing.</p>
                                        </div>
                                        <div class="carousel-item active">
                                            <h6 class="text-white">Committed to Fair Assessment</h6>
                                            <p class="fs-15 fst-italic">Every test, every score, every candidate, evaluated with integrity and fairness.</p>
                                        </div>
                                        <div class="carousel-item">
                                            <h6 class="text-white">Smart Testing. Bright Future.</h6>
                                            <p class="fs-15 fst-italic">Take your test with confidence — your performance today shapes your tomorrow.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import UserLoginForm from '@/components/forms/UserLoginForm.vue'

export default {
  components:{
    UserLoginForm
  },
  methods: {
    takeAction(data){
      if(data.redirect_url){
        location.replace(data.redirect_url); return;
      }
      this.$store.commit('SET_AUTH_TOKEN', data);
      if(this.$route.query.intended){
        const decodedUrl = this.$filters.decodeURL(this.$route.query.intended);
        location.replace(decodedUrl)
      }else{
        location.replace(document.baseURI)
      }
    },
   },
}
</script>


<style>
.user-login .auth-one-bg {
  background-position: center;
  background-size: cover;
}

.user-login .auth-one-bg .bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  /* background-color: #cc8800; */
  background-color: #224326;
  background-image: url("https://www.transparenttextures.com/patterns/black-orchid.png");
  /* background: linear-gradient(134deg, rgba(0, 0, 0, 1) 0%, rgba(0, 125, 83, 0.7) 400px);; */
  opacity: 1;
}

.user-login .text-white-70{
  color: rgba(255, 255, 255, 1) !important
}


.user-login .carousel-indicators [data-bs-target]{
  background-color: var(--bs-primary);
}
</style>